import {
  CLEAR_CATALOG_SEARCH,
  FETCH_CATALOG_SEARCH,
  FETCH_CATALOG_SEARCH_FULFILLED,
  FETCH_CATALOG_SEARCH_REJECTED,
} from 'b2b-apps/shop/catalog/redux/search/actionTypes';
import {
  CatalogSearchType,
  ClearCatalogSearchAction,
  FetchCatalogSearchAction,
  FetchCatalogSearchFulfilledAction,
  FetchCatalogSearchRejectedAction,
} from 'b2b-apps/shop/catalog/redux/search/types';

const clearSearchProducts = (): ClearCatalogSearchAction => ({
  type: CLEAR_CATALOG_SEARCH,
});

const fetchCatalogSearch = (
  query: string,
  identifier: string,
): FetchCatalogSearchAction => ({
  type: FETCH_CATALOG_SEARCH,
  payload: {
    query,
    identifier,
  },
});

const fetchCatalogSearchFulfilled = (
  response: CatalogSearchType,
  identifier: string,
): FetchCatalogSearchFulfilledAction => ({
  type: FETCH_CATALOG_SEARCH_FULFILLED,
  payload: {
    data: response,
    identifier,
  },
});

const fetchCatalogSearchRejected = (
  error: ErrorType,
): FetchCatalogSearchRejectedAction => ({
  type: FETCH_CATALOG_SEARCH_REJECTED,
  payload: {
    error,
  },
});

export {
  clearSearchProducts,
  fetchCatalogSearch,
  fetchCatalogSearchFulfilled,
  fetchCatalogSearchRejected,
};
